module.exports = __webpack_public_path__ + "img/img_my_ skill_brand@3x.ff93cb14.png";